import React from 'react';

export default function Switch({ checked = false, onChange, nomargin, disabled = false }) {
    return (
        <span className="kt-switch kt-switch--icon">
            <label style={{ marginBottom: nomargin ? 0 : '0.5rem' }}>
                <input disabled={disabled} onClick={(e) => onChange(e.target.checked)} type="checkbox" checked={checked} defaultChecked={checked} name=""/>
                <span></span>
            </label>
        </span>
    );
}